import * as React from 'react';
export default function SvgDrink() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.63 18.387l-1.723-12.5a1 1 0 01.99-1.137h10.206a1 1 0 01.99 1.137l-1.724 12.5a1 1 0 01-.99.863H8.622a1 1 0 01-.991-.863z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12s2-2 5 0 5 0 5 0",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}